import { ParametrosWSBase, DestinoConexion } from "../../../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../../../EncabezadoRespuestaInterna";

export function AccountPreregistration_Parametros(datos: any,p_crc:string|null) {
  var par: ParametrosWSBase = {
    nombreProceso: "AccountPreregistration",
    rutaEndPoint: "/izzi/registro/preregistro",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
    cRC:p_crc
  };

  return par;
}

//ENTRADA

export interface AccountPreregistration_Request {
    email:      string;
    noContrato: string;
    cp:         string;
    password:   string;
}

export function builtAccountPreregistrationRequest(
  p_email:      string,
  p_numerocontrato: string,
  p_codigopostal:         string,
  p_password:   string
) {
  var retorno: AccountPreregistration_Request = {
    email:      p_email,
    noContrato: p_numerocontrato,
    cp:         p_codigopostal,
    password:   p_password,
};

  return retorno;
}

export interface AccountPreregistration_Response {
    ident:   string;
    nombre:  string;
    message: string;
}

